export default ['api', 'basketApiService', 'basket', 'storeService', function (api, basketApiService, basket, storeService) {
    const callUpgradeApi = (payload, error) => {
        basket.saving = true;
        const basketCode = storeService.get('basket');

        return api.post(`checkout/basket/${basketCode}/upgrade`, payload)
            .then(() => {
                return basketApiService.retrieveBasket(basketCode, true).then(response => {
                    basket.contents = response;

                    basket.saving = false;
                });
            }).catch(() => {
                basket.saving = false;
                throw error;
            });
    };

    const upgrade = (events) => {
        return callUpgradeApi({
            'guest_items': events.map(event => event.id)
        }, {
            message: 'Error upgrading events'
        });
    };

    return {
        upgrade
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/upgrade.service.js